import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerIcon} from '../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../libs/shared/ui/src/components/banners/bannerText';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface LeftSandboxBannerProps {
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const LeftSandboxBanner: FC<LeftSandboxBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.INLINE}
      color={theme.banner.successBackground}
      priority={BannerPrioritiesEnum.TRANSIENT}
    >
      <BannerIcon iconName="checkmarkCircleSmall" />
      <BannerText>
        <Trans id="left-sandbox-workspace-banner-text">Left the sandbox workspace</Trans>
      </BannerText>
      <BannerCloseAction onClick={props.onRequestClose} />
    </Banner>
  );
};
